import { useCallback } from "react"

import { useCloudFunction } from "../../../hooks/useCloudFunction"
import { firebase } from "../../../services/firebase/firebase"
import { useAuth } from "../../../contexts/authentication-context"
import { useLanguage } from "../../../contexts/language-context"

export default () => {
    const { onStart, onSuccess, onError, processing } = useCloudFunction("aws-lambda-describeOrganisation")
    const { user } = useAuth()
    const { L } = useLanguage()
    let url = `https://${firebase.functions.region}-${firebase.app.options.projectId}.cloudfunctions.net/aws-lambda-describeOrganisation`
    if (process.env.NODE_ENV === 'development') url = `http://localhost:5001/${firebase.app.options.projectId}/${firebase.functions.region}/aws-lambda-describeOrganisation`

    const onSync = useCallback(() => {
        if (user) {
            onStart(L(`Synchronising organisation %s...`, user.organisation), "")
            fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ organisation: user.organisation }),
            })
                .then(async res => {
                    if (res.ok) onSuccess(L("App synchronised successfully!"))()
                    else console.error(res.status, res.statusText, await res.json())
                })
                .catch(onError(L("Something went wrong whilst %s!", L(`synchronising organisation %s`, user.organisation))))
        }
    }, [user])

    return { onSync, processing }
}
